import { getEntryEditSourceText } from "../../utils/entryEditMode";
import { getTimelineEntryEditTarget } from "../../utils/timelineEntryBehavior";

const resolveTimelineEditTarget = (entry = {}, entryConfig = null) => {
  return entryConfig?.editTarget || getTimelineEntryEditTarget(entry, entryConfig);
};

const buildPanelDashboardEditEntry = (entry = {}, entryConfig = null) => {
  const sourceText = getEntryEditSourceText(entry, entryConfig);
  const behaviorType = entryConfig?.behaviorType || entry.behaviorType || null;
  const editTarget = entryConfig?.editTarget || getTimelineEntryEditTarget(entry, entryConfig);

  return {
    ...entry,
    behaviorType,
    editTarget,
    sourceText,
    noteContextText: sourceText,
    originalData: {
      ...(entry.originalData || {}),
      behaviorType,
      editTarget,
      sourceText,
      noteContextText: sourceText,
    },
  };
};

const applyPanelDashboardEditRoute = ({
  child,
  editEntry,
  entryConfig,
  handleEditMedicalLog,
  setBathroomLogChild,
  setBathroomLogEditEntry,
  setCurrentChildId,
  setDailyCareAction,
  setDailyCareChild,
  setDailyCareEditEntry,
  setFoodLogChild,
  setFoodLogEditEntry,
  setIncidentChild,
  setIncidentEditEntry,
  setMoodSheetChild,
  setMoodSheetEntry,
  setShowBathroomLogSheet,
  setShowDailyCareModal,
  setShowFoodLogSheet,
  setShowIncidentModal,
  setShowSmartCaptureNoteSheet,
  setShowMoodSheet,
  setShowSleepLogSheet,
  setSleepLogChild,
  setSleepLogEditEntry,
  setSleepLogType,
  setSmartCaptureNoteChild,
  setSmartCaptureNoteEditEntry,
  setShowTimelineNoteEditSheet,
  setTimelineNoteEditChild,
  setTimelineNoteEditEntry,
}) => {
  const editTarget = resolveTimelineEditTarget(editEntry, entryConfig);
  setCurrentChildId(child.id);

  const isSmartCaptureNote = editTarget === 'note'
    && Boolean(
      editEntry?.source?.parsedObservation
      || editEntry?.parsedObservation
      || entryConfig?.source?.parsedObservation
      || entryConfig?.parsedObservation
    )
    && ['mood', 'sleep'].includes(String(editEntry?.category || entryConfig?.category || '').toLowerCase());

  if (isSmartCaptureNote) {
    setSmartCaptureNoteChild(child);
    setSmartCaptureNoteEditEntry(editEntry);
    setShowSmartCaptureNoteSheet(true);
    return;
  }

  if (editTarget === 'sleep') {
    setSleepLogChild(child);
    setSleepLogEditEntry(editEntry);
    setSleepLogType(editEntry?.sleepDetails?.type || editEntry?.originalData?.sleepDetails?.type || 'night');
    setShowSleepLogSheet(true);
    return;
  }

  if (editTarget === 'food') {
    setFoodLogChild(child);
    setFoodLogEditEntry(editEntry);
    setShowFoodLogSheet(true);
    return;
  }

  if (editTarget === 'bathroom' || editTarget === 'toileting') {
    setBathroomLogChild(child);
    setBathroomLogEditEntry(editEntry);
    setShowBathroomLogSheet(true);
    return;
  }

  if (editTarget === 'medication') {
    handleEditMedicalLog(child, editEntry);
    return;
  }

  if (editTarget === 'activity') {
    setDailyCareAction('activity');
    setDailyCareChild(child);
    setDailyCareEditEntry(editEntry);
    setShowDailyCareModal(true);
    return;
  }

  if (editTarget === 'behavior') {
    setIncidentChild(child);
    setIncidentEditEntry(editEntry);
    setShowIncidentModal(true);
    return;
  }

  if (editTarget === 'mood') {
    setMoodSheetChild(child);
    setMoodSheetEntry(editEntry);
    setShowMoodSheet(true);
    return;
  }

  setTimelineNoteEditChild(child);
  setTimelineNoteEditEntry(editEntry);
  setShowTimelineNoteEditSheet(true);
};

export { applyPanelDashboardEditRoute, buildPanelDashboardEditEntry };
